import { I18n } from "i18n-js";
import translations from "../locales/es-CR.json";

const i18n = new I18n({
  "es-CR": translations["es-CR"]
});

i18n.locale = "es-CR";
i18n.defaultLocale = "es-CR";
i18n.translations ||= {};

export { i18n };
